import { render, staticRenderFns } from "./MoleculeEditionAssetSignedStudents.vue?vue&type=template&id=2f14a6cc&"
import script from "./MoleculeEditionAssetSignedStudents.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetSignedStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports